<template>
  <form method="post" @submit.prevent="send" novalidate>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ $t('attributes.save_as') + $t('attributes.product') }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="type"
            attribute="attributes.product_type"
            :label="$t('attributes.product_type')"
          >
            <b-select
              v-model="form.type"
              name="type"
              :placeholder="
                $t('message.please_select') + $t('attributes.product_type')
              "
              expanded
            >
              <option value="" disabled>
                {{
                  $t('message.please_select') + $t('attributes.product_type')
                }}
              </option>
              <option
                v-for="(type, idx) in productTypes"
                :key="idx"
                :value="type.value"
              >
                {{ type.name }}
              </option>
            </b-select>
          </form-group>

          <form-group horizontal name="days" :label="$t('attributes.days')">
            <b-select
              v-model.number="form.days"
              name="days"
              :placeholder="$t('message.please_select') + $t('attributes.days')"
            >
              <option value="" disabled>
                {{ $t('message.please_select') + $t('attributes.days') }}
              </option>
              <option v-for="option in days" :key="option" :value="option">
                {{ option }}
              </option>
            </b-select>
          </form-group>

          <form-group
            red="code_input"
            horizontal
            name="code"
            attribute="attributes.product_code"
            :label="$t('attributes.product_code')"
          >
            <b-field>
              <p class="control">
                <span class="button is-static">
                  {{ area_code }}
                </span>
              </p>
              <b-input
                v-model="form.code"
                name="code"
                maxlength="5"
                :has-counter="false"
                :placeholder="
                  $t('message.please_input') + $t('attributes.product_code')
                "
                @input="form.code = form.code.toUpperCase()"
                expanded
              ></b-input>
              <p class="control">
                <span class="button is-static">
                  {{ form.days ? form.days.toString().padStart(2, 0) : '??' }}
                </span>
              </p>
            </b-field>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="isSending" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button :loading="isSending" type="is-primary" native-type="submit">
          {{ $t('attributes.save_as') }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import {
  required,
  numeric,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'

export default {
  name: 'TravelGroupCloneForm',

  props: {
    product: {
      required: true,
      type: Object
    },
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const productTypes = this.GetProductTypes()

    return {
      productTypes,
      days: [...Array(30).keys()].map(i => i + 1),

      area_code: this.product.area_code,
      form: {
        type: null,
        days: null,
        code: ''
      }
    }
  },
  validations: {
    form: {
      type: { required },
      days: { required, numeric },
      code: { required, minLength: minLength(5), maxLength: maxLength(5) }
    }
  },
  mounted() {
    this.$refs.code_input.focus()
  },
  methods: {
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.product.code, this.form)
    }
  }
}
</script>
